
import React, { useState, useEffect, useRef } from 'react';
import {
    Box, Grid, Typography, TextField, Button, MenuItem,
    Select, FormControl, InputLabel, IconButton, Chip,
    InputAdornment, Paper, CircularProgress, Snackbar, Alert,
    Divider,Dialog,DialogTitle,DialogContent,DialogActions } from '@mui/material';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import SchoolIcon from '@mui/icons-material/School';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import CancelIcon from '@mui/icons-material/Cancel';
import TimerIcon from '@mui/icons-material/Timer';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EventIcon from '@mui/icons-material/Event';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import axiosInstance from '../../../../lib/axios';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useLocation, useNavigate } from 'react-router-dom'; 
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';


const getCurrentDateTime = () => {
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const yyyy = now.getFullYear();
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
};


const getCurrentDateForPicker = () => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

// Helper: Get current time in HH:MM format
const getCurrentTime = () => {
    const now = new Date();
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    return `${hh}:${min}`;
};

// Helper: Calculate time difference in minutes and seconds
const calculateTimeDifference = (orderTime, currentTime) => {
    if (!orderTime || !currentTime) return null;
    
    const [orderHour, orderMinute, orderSecond = 0] = orderTime.split(':').map(Number);
    const [currentHour, currentMinute, currentSecond = 0] = currentTime.split(':').map(Number);
    
    const orderTotalSeconds = orderHour * 3600 + orderMinute * 60 + orderSecond;
    const currentTotalSeconds = currentHour * 3600 + currentMinute * 60 + currentSecond;
    
    let diff = orderTotalSeconds - currentTotalSeconds;
    
    return { 
        hours: Math.floor(diff / 3600),
        minutes: Math.floor((diff % 3600) / 60),
        seconds: diff % 60,
        totalSeconds: diff,
        isExpired: diff <= 0
    };
};

// Helper: Get current time in HH:MM:SS format
const getCurrentTimeWithSeconds = () => {
    const now = new Date();
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    const sec = String(now.getSeconds()).padStart(2, '0');
    return `${hh}:${min}:${sec}`;
};

const TiffinDelivery = () => {
    const globalPropertyId = useSelector(selectGlobalProperty);
    const navigate = useNavigate();
    const [institutes, setInstitutes] = useState([]);
    const [dropLocations, setDropLocations] = useState([]);
    const [mealTypes, setMealTypes] = useState([]);
    const location = useLocation();
    const [restoring, setRestoring] = useState(false);
    const [loadingInstitutes, setLoadingInstitutes] = useState(false);
    const [loadingDropLocations, setLoadingDropLocations] = useState(false);
    const [loadingMealTypes, setLoadingMealTypes] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [currentOrderId, setCurrentOrderId] = useState(null);
    const [currentOrderData, setCurrentOrderData] = useState(null); 
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
const [cancelling, setCancelling] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });
    
    const [formData, setFormData] = useState({
        customerName: '',
        phone: '',
        institute: '',
        instituteName: '',
        mealType: '',
        mealTypeName: '',
        pickupAddress: '',
        dropAddress: '',
        otp: '',
        tiffinCount: 1,
        selectedMenu: null,
        deliveryDate: dayjs(), // Changed to dayjs object
        deliveryTime: dayjs(), // New field for delivery time
        orderTime: '',
        orderTimeOriginal: '',
        cancelTime: '',
        cancelTimeOriginal: '',
        specialInstructions: '',
        status: 'Pending'
    });
    
    const [otpSent, setOtpSent] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [mode, setMode] = useState('view');
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [timeRemaining, setTimeRemaining] = useState(null);
    const [bookingDisabled, setBookingDisabled] = useState(false);

   
const fetchSingleOrderWithRetry = async (orderId, maxRetries = 3, delay = 500) => {
    for (let i = 0; i < maxRetries; i++) {
        const order = await fetchSingleOrder(orderId);
        if (order && order.Dlv_OTP) {
            return order;
        }
        // Wait before retry
        await new Promise(resolve => setTimeout(resolve, delay));
    }
    // Final attempt without OTP requirement
    return await fetchSingleOrder(orderId);
};

    // Fetch single order function (moved here to be accessible)
    const fetchSingleOrder = async (orderId) => {
        try {
            const response = await axiosInstance.post('TrnTiffin/RetriveTrnTiffin', {
                Id: orderId,
                Flag: "R"
            });

            if (response.data?.Data && response.data.Data.length > 0) {
                return response.data.Data[0];
            }
            return null;
        } catch (error) {
            console.error('Error fetching order details:', error);
            toast.error('Error fetching order details');
            return null;
        }
    };

   // Replace your existing refreshOrderData function with this:
const refreshOrderData = async (orderId) => {
    if (!orderId) return;
    
    // Use retry logic to ensure OTP is fetched
    const updatedOrder = await fetchSingleOrderWithRetry(orderId);
    if (updatedOrder) {
        setCurrentOrderData(updatedOrder);
        // Update form data with latest values including OTP
        setFormData(prev => ({
            ...prev,
            customerName: updatedOrder.Remark?.replace('Order from ', '') || '',
            phone: updatedOrder.MobileNo || '',
            institute: updatedOrder.InstituteId?.toString() || '',
            instituteName: updatedOrder.InstituteName || '',
            mealType: updatedOrder.MealTypeId?.toString() || '',
            mealTypeName: updatedOrder.MealTypeName || '',
            pickupAddress: updatedOrder.PickupAddress || '',
            dropAddress: updatedOrder.Dlv_Loc || '',
            otp: updatedOrder.Dlv_OTP || '',
            tiffinCount: updatedOrder.Req_Qty || 1,
            deliveryDate: updatedOrder.Dlv_Time ? dayjs(updatedOrder.Dlv_Time) : dayjs(),
            deliveryTime: updatedOrder.Dlv_Time ? dayjs(updatedOrder.Dlv_Time) : dayjs(),
            orderTime: updatedOrder.Req_LockTime ? formatTimeForDisplay(updatedOrder.Req_LockTime) : '',
            orderTimeOriginal: updatedOrder.Req_LockTime ? formatTimeForDisplay(updatedOrder.Req_LockTime) : '',
            cancelTime: updatedOrder.Req_CanlTime ? formatTimeForDisplay(updatedOrder.Req_CanlTime) : '',
            cancelTimeOriginal: updatedOrder.Req_CanlTime ? formatTimeForDisplay(updatedOrder.Req_CanlTime) : '',
            specialInstructions: updatedOrder.Req_Remark || '',
            status: updatedOrder.Tfn_ReqSt || 'Pending'
        }));
        
        // Show OTP in snackbar or toast if available
        // if (updatedOrder.Dlv_OTP) {
        //     toast.success(`Order placed successfully! OTP: ${updatedOrder.Dlv_OTP}`);
        // } else {
        //     toast.success('Order placed successfully!');
        // }
    }
};

    useEffect(() => {
        const state = location.state;
        if (state) {
            const { mode: navMode, orderData } = state;
            
            if (navMode === 'view') {
                setMode('view');
                setIsFormDisabled(true);
                setCurrentOrderData(orderData);
                if (orderData) {
                    setCurrentOrderId(orderData.Tfn_ReqId);
                    setFormData({
                        customerName: orderData.Remark?.replace('Order from ', '') || '',
                        phone: orderData.MobileNo || '',
                        institute: orderData.InstituteId?.toString() || '',
                        instituteName: orderData.InstituteName || '',
                        mealType: orderData.MealTypeId?.toString() || '',
                        mealTypeName: orderData.MealTypeName || '',
                        pickupAddress: orderData.PickupAddress || '',
                        dropAddress: orderData.Dlv_Loc || '',
                        otp: orderData.Dlv_OTP || '',
                        tiffinCount: orderData.Req_Qty || 1,
                        selectedMenu: null,
                        deliveryDate: orderData.Dlv_Time ? dayjs(orderData.Dlv_Time) : dayjs(),
                        deliveryTime: orderData.Dlv_Time ? dayjs(orderData.Dlv_Time) : dayjs(),
                        orderTime: orderData.Req_LockTime ? formatTimeForDisplay(orderData.Req_LockTime) : '',
                        orderTimeOriginal: orderData.Req_LockTime ? formatTimeForDisplay(orderData.Req_LockTime) : '',
                        cancelTime: orderData.Req_CanlTime ? formatTimeForDisplay(orderData.Req_CanlTime) : '',
                        cancelTimeOriginal: orderData.Req_CanlTime ? formatTimeForDisplay(orderData.Req_CanlTime) : '',
                        specialInstructions: orderData.Req_Remark || '',
                        status: orderData.Tfn_ReqSt || 'Pending'
                    });
                    
                    if (orderData.InstituteId) {
                        fetchDropLocations(orderData.InstituteId);
                    }
                }
            } else if (navMode === 'edit') {
                setMode('edit');
                setIsFormDisabled(false);
                setCurrentOrderData(orderData);
                if (orderData) {
                    setCurrentOrderId(orderData.Tfn_ReqId);
                    setFormData({
                        customerName: orderData.Remark?.replace('Order from ', '') || '',
                        phone: orderData.MobileNo || '',
                        institute: orderData.InstituteId?.toString() || '',
                        instituteName: orderData.InstituteName || '',
                        mealType: orderData.MealTypeId?.toString() || '',
                        mealTypeName: orderData.MealTypeName || '',
                        pickupAddress: orderData.PickupAddress || '',
                        dropAddress: orderData.Dlv_Loc || '',
                        otp: orderData.Dlv_OTP || '',
                        tiffinCount: orderData.Req_Qty || 1,
                        selectedMenu: null,
                        deliveryDate: orderData.Dlv_Time ? dayjs(orderData.Dlv_Time) : dayjs(),
                        deliveryTime: orderData.Dlv_Time ? dayjs(orderData.Dlv_Time) : dayjs(),
                        orderTime: orderData.Req_LockTime ? formatTimeForDisplay(orderData.Req_LockTime) : '',
                        orderTimeOriginal: orderData.Req_LockTime ? formatTimeForDisplay(orderData.Req_LockTime) : '',
                        cancelTime: orderData.Req_CanlTime ? formatTimeForDisplay(orderData.Req_CanlTime) : '',
                        cancelTimeOriginal: orderData.Req_CanlTime ? formatTimeForDisplay(orderData.Req_CanlTime) : '',
                        specialInstructions: orderData.Req_Remark || '',
                        status: orderData.Tfn_ReqSt || 'Pending'
                    });
                    
                    if (orderData.InstituteId) {
                        fetchDropLocations(orderData.InstituteId);
                    }
                }
            } else if (navMode === 'add') {
                setMode('add');
                setIsFormDisabled(false);
                setCurrentOrderId(null);
                setCurrentOrderData(null);
            }
        }
    }, [location.state]);

   
const handleCancelOrder = async () => {
    if (!currentOrderId) {
        setSnackbar({ open: true, message: 'No order found to cancel', severity: 'error' });
        return;
    }
    
    setCancelling(true);
    
    try {
        const user = getUserData();
        if (!user) {
            setSnackbar({ open: true, message: 'User not found. Please login again.', severity: 'error' });
            return;
        }
        
        // Get current system time for Req_Date
        const currentDateTime = dayjs();
        
        // Combine date and time for delivery datetime
        const deliveryDateTime = dayjs(formData.deliveryDate)
            .hour(formData.deliveryTime.hour())
            .minute(formData.deliveryTime.minute());
        
        const payload = {
            Tfn_ReqId: currentOrderId,
            Req_Date: currentDateTime.format('YYYY-MM-DD HH:mm:ss'),
            Req_RaisedId: user.UserId,
            MealTypeId: parseInt(formData.mealType),
            Req_LockTime: formatTimeForAPI(dayjs().hour(parseInt(formData.orderTimeOriginal.split(':')[0])).minute(parseInt(formData.orderTimeOriginal.split(':')[1]))),
            Req_CanlTime: formatTimeForAPI(dayjs().hour(parseInt(formData.cancelTimeOriginal.split(':')[0])).minute(parseInt(formData.cancelTimeOriginal.split(':')[1]))),
            PropId: parseInt(globalPropertyId),
            BookId: 1,
            ResidentId: 1,
            InstituteId: parseInt(formData.institute),
            Dlv_Time: deliveryDateTime.format('YYYY-MM-DD HH:mm:ss'),
            Dlv_Loc: formData.dropAddress,
            Req_Qty: formData.tiffinCount,
            Req_Remark: formData.specialInstructions || "",
            Tfn_ReqSt: "Cancelled",  
            Status: "0",  
            Remark: `Order from ${formData.customerName || 'Guest'}`,
            CreatedBy: user.UserId,
            MobileNo: formData.phone || user.MobileNo || ""
        };
        
        console.log('Cancelling order payload:', payload);
        
        const response = await axiosInstance.post('TrnTiffin/UpdateTrnTiffin', payload);
        
        if (response.data?.Status === 0 || response.data?.Success) {
            toast.success('Order cancelled successfully!');
            
            // Refresh order data after cancel
            await refreshOrderData(currentOrderId);
            
            // Close cancel dialog
            setCancelDialogOpen(false);
            
            // Switch to view mode after successful cancel
            switchToViewMode();
        } else {
            throw new Error(response.data?.Message || 'Failed to cancel order');
        }
    } catch (err) {
        console.error('Error cancelling order:', err);
        setSnackbar({
            open: true,
            message: err.response?.data?.Message || err.message || 'Failed to cancel order. Please try again.',
            severity: 'error'
        });
    } finally {
        setCancelling(false);
    }
};

    const formatDateForDisplay = (dateTimeString) => {
        if (!dateTimeString) return getCurrentDateTime();
        const date = new Date(dateTimeString);
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        const hh = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
    };

    const formatTimeForDisplay = (dateTimeString) => {
        if (!dateTimeString) return '';
        const date = new Date(dateTimeString);
        const hh = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        return `${hh}:${min}`;
    };
    
    const getUserData = () => {
        try {
            const authData = localStorage.getItem('persist:hostelerp-auth');
            if (authData) {
                const parsedData = JSON.parse(authData);
                if (parsedData.user) {
                    const user = JSON.parse(parsedData.user);
                    return user;
                }
            }
        } catch (err) {
            console.error('Error parsing user data:', err);
        }
        return null;
    };
    
// Replace your timer useEffect with this:
useEffect(() => {
    if (!formData.orderTimeOriginal || isFormDisabled || mode === 'view') {
        setTimeRemaining(null);
        setBookingDisabled(false);
        return;
    }
    
    // Get the lock time for the selected delivery date
    const selectedDeliveryDate = formData.deliveryDate;
    const today = dayjs().startOf('day');
    const isToday = selectedDeliveryDate.isSame(today);
    
    // Parse the lock time (order time)
    const [lockHour, lockMinute] = formData.orderTimeOriginal.split(':').map(Number);
    
    // Create a datetime object for the lock time on the delivery date
    const lockDateTime = dayjs(selectedDeliveryDate)
        .hour(lockHour)
        .minute(lockMinute)
        .second(0);
    
    const updateTimer = () => {
        const now = dayjs();
        
        // Calculate difference in seconds
        let diffSeconds = lockDateTime.diff(now, 'second');
        
        if (diffSeconds <= 0) {
            // Order window is closed for this date
            setTimeRemaining({ 
                hours: 0, 
                minutes: 0, 
                seconds: 0, 
                totalSeconds: 0, 
                isExpired: true 
            });
            setBookingDisabled(true);
        } else {
            // Order window is open
            const hours = Math.floor(diffSeconds / 3600);
            const minutes = Math.floor((diffSeconds % 3600) / 60);
            const seconds = diffSeconds % 60;
            
            setTimeRemaining({ 
                hours, 
                minutes, 
                seconds, 
                totalSeconds: diffSeconds, 
                isExpired: false 
            });
            setBookingDisabled(false);
        }
    };
    
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    
    return () => clearInterval(interval);
}, [formData.orderTimeOriginal, formData.deliveryDate, isFormDisabled, mode]);

// Replace your delivery date change useEffect with this:
useEffect(() => {
    // When delivery date changes, re-evaluate booking availability
    if (formData.orderTimeOriginal && !isFormDisabled && mode !== 'view') {
        const selectedDeliveryDate = formData.deliveryDate;
        const now = dayjs();
        
        const [lockHour, lockMinute] = formData.orderTimeOriginal.split(':').map(Number);
        const lockDateTime = dayjs(selectedDeliveryDate)
            .hour(lockHour)
            .minute(lockMinute)
            .second(0);
        
        if (now.isAfter(lockDateTime)) {
            setBookingDisabled(true);
            setTimeRemaining({ 
                hours: 0, 
                minutes: 0, 
                seconds: 0, 
                totalSeconds: 0, 
                isExpired: true 
            });
        } else {
            setBookingDisabled(false);
            // Timer will be handled by the main useEffect
        }
    }
}, [formData.deliveryDate, formData.orderTimeOriginal]);
    
    useEffect(() => {
        const fetchInstitutes = async () => {
            setLoadingInstitutes(true);
            try {
                const response = await axiosInstance.post('MstInstitute/getMstInstitutedrp', {});
                if (response.data?.Data) setInstitutes(response.data.Data);
            } catch (err) {
                console.error('Error fetching institutes:', err);
            } finally {
                setLoadingInstitutes(false);
            }
        };
        fetchInstitutes();
    }, []);
    
    useEffect(() => {
      const fetchMealTypes = async () => {
    setLoadingMealTypes(true);
    try {
        const response = await axiosInstance.post('MstFood/GetdrpMstMealType', { Flag: 'TiffinService' });
        if (response.data?.Data) {
            // Don't filter - show all meal types
            setMealTypes(response.data.Data);
        }
    } catch (err) {
        console.error('Error fetching meal types:', err);
    } finally {
        setLoadingMealTypes(false);
    }
};
        fetchMealTypes();
    }, []);
    
    const fetchDropLocations = async (instituteId) => {
        if (!instituteId) {
            setDropLocations([]);
            return;
        }
        setLoadingDropLocations(true);
        try {
            const response = await axiosInstance.post('MstInstitute/RetriveMstInstituteDtl', {
                InstituteId: instituteId,
                Flag: 'P'
            });
            setDropLocations(response.data?.Data ?? []);
        } catch (err) {
            console.error('Error fetching drop locations:', err);
            setDropLocations([]);
        } finally {
            setLoadingDropLocations(false);
        }
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    
    const handleInstituteChange = (e) => {
        const selectedId = e.target.value;
        const selectedInst = institutes.find(i => i.Id === selectedId);
        setFormData(prev => ({
            ...prev,
            institute: selectedId,
            instituteName: selectedInst?.Name ?? '',
            dropAddress: '',
        }));
        fetchDropLocations(selectedId);
    };
    
    const handleMealTypeChange = (e) => {
        const selectedId = e.target.value;
        const selectedMeal = mealTypes.find(m => m.MealTypeId === selectedId);
        
        const orderTimeValue = selectedMeal?.Req_LockTime ? selectedMeal.Req_LockTime.substring(0, 5) : '';
        const cancelTimeValue = selectedMeal?.Req_CanlTime ? selectedMeal.Req_CanlTime.substring(0, 5) : '';
        
        setFormData(prev => ({
            ...prev,
            mealType: selectedId,
            mealTypeName: selectedMeal?.MealTypeName ?? '',
            orderTime: orderTimeValue,
            orderTimeOriginal: orderTimeValue,
            cancelTime: cancelTimeValue,
            cancelTimeOriginal: cancelTimeValue,
        }));
        
        setTimeRemaining(null);
        setBookingDisabled(false);
    };
    
    const handleTiffinInput = (e) => {
    const val = e.target.value;
    if (val === '') {
        setFormData(prev => ({ ...prev, tiffinCount: '' }));
        return;
    }
    const num = parseInt(val);
    if (!isNaN(num) && num >= 1)  
        setFormData(prev => ({ ...prev, tiffinCount: num }));
};
    
    const handleTiffinCount = (action) => {
        setFormData(prev => {
            const current = parseInt(prev.tiffinCount) || 1;
            return {
                ...prev,
                tiffinCount: action === 'inc' ? Math.min(current + 1, 99) : Math.max(current - 1, 1)
            };
        });
    };
    
    const handleSendOtp = () => {
        if (formData.phone.length === 10) setOtpSent(true);
    };
    
    const handleVerifyOtp = () => {
        if (formData.otp.length === 6) setOtpVerified(true);
    };
    
    const formatDateForAPI = (date) => {
        if (!date) return '';
        return date.format('YYYY-MM-DD');
    };
    
    const formatTimeForAPI = (time) => {
        if (!time) return '';
        return `${time.format('HH:mm')}:00`;
    };
    
// Replace your validateBookingTime function with this:
const validateBookingTime = () => {
    if (!formData.orderTimeOriginal) {
        setSnackbar({ open: true, message: 'Please select a meal type first', severity: 'error' });
        return false;
    }
    
    const selectedDeliveryDate = formData.deliveryDate;
    const now = dayjs();
    
    // Parse the lock time
    const [lockHour, lockMinute] = formData.orderTimeOriginal.split(':').map(Number);
    
    // Create datetime object for lock time on delivery date
    const lockDateTime = dayjs(selectedDeliveryDate)
        .hour(lockHour)
        .minute(lockMinute)
        .second(0);
    
    // Check if lock time has passed for the selected delivery date
    if (now.isAfter(lockDateTime)) {
        const formattedDate = selectedDeliveryDate.format('DD/MM/YYYY');
        setSnackbar({ 
            open: true, 
            message: `Booking is closed for ${formData.mealTypeName} on ${formattedDate}. Order time was ${formData.orderTimeOriginal}. Please select another meal type or choose a different delivery date.`, 
            severity: 'error' 
        });
        return false;
    }
    
    return true;
};

// Add this function after handleCancelOrder function
const handleRestoreOrder = async () => {
    if (!currentOrderId) {
        setSnackbar({ open: true, message: 'No order found to restore', severity: 'error' });
        return;
    }
    
    // Check if cancellation time has passed
    const selectedDeliveryDate = formData.deliveryDate;
    const [lockHour, lockMinute] = formData.cancelTimeOriginal.split(':').map(Number);
    const cancelDateTime = dayjs(selectedDeliveryDate)
        .hour(lockHour)
        .minute(lockMinute)
        .second(0);
    const now = dayjs();
    
    if (now.isAfter(cancelDateTime)) {
        setSnackbar({ 
            open: true, 
            message: `Cannot restore order. Cancellation time was ${formData.cancelTimeOriginal} on ${selectedDeliveryDate.format('DD/MM/YYYY')}. Please contact support.`, 
            severity: 'error' 
        });
        return;
    }
    
    setSubmitting(true);
    
    try {
        const user = getUserData();
        if (!user) {
            setSnackbar({ open: true, message: 'User not found. Please login again.', severity: 'error' });
            return;
        }
        
        // Get current system time for Req_Date
        const currentDateTime = dayjs();
        
        // Combine date and time for delivery datetime
        const deliveryDateTime = dayjs(formData.deliveryDate)
            .hour(formData.deliveryTime.hour())
            .minute(formData.deliveryTime.minute());
        
        const payload = {
            Tfn_ReqId: currentOrderId,
            Req_Date: currentDateTime.format('YYYY-MM-DD HH:mm:ss'),
            Req_RaisedId: user.UserId,
            MealTypeId: parseInt(formData.mealType),
            Req_LockTime: formatTimeForAPI(dayjs().hour(parseInt(formData.orderTimeOriginal.split(':')[0])).minute(parseInt(formData.orderTimeOriginal.split(':')[1]))),
            Req_CanlTime: formatTimeForAPI(dayjs().hour(parseInt(formData.cancelTimeOriginal.split(':')[0])).minute(parseInt(formData.cancelTimeOriginal.split(':')[1]))),
            PropId: parseInt(globalPropertyId),
            BookId: 1,
            ResidentId: 1,
            InstituteId: parseInt(formData.institute),
            Dlv_Time: deliveryDateTime.format('YYYY-MM-DD HH:mm:ss'),
            Dlv_Loc: formData.dropAddress,
            Req_Qty: formData.tiffinCount,
            Req_Remark: formData.specialInstructions || "",
            Tfn_ReqSt: "Booked",  // Restore to Booked
            Status: "1",  // Restore to active status
            Remark: `Order from ${formData.customerName || 'Guest'}`,
            CreatedBy: user.UserId,
            MobileNo: formData.phone || user.MobileNo || ""
        };
        
        console.log('Restoring order payload:', payload);
        
        const response = await axiosInstance.post('TrnTiffin/UpdateTrnTiffin', payload);
        
        if (response.data?.Status === 0 || response.data?.Success) {
            toast.success('Order restored successfully!');
            
            // Refresh order data after restore
            await refreshOrderData(currentOrderId);
            
            // Switch to view mode after successful restore
            switchToViewMode();
        } else {
            throw new Error(response.data?.Message || 'Failed to restore order');
        }
    } catch (err) {
        console.error('Error restoring order:', err);
        setSnackbar({
            open: true,
            message: err.response?.data?.Message || err.message || 'Failed to restore order. Please try again.',
            severity: 'error'
        });
    } finally {
        setSubmitting(false);
    }
};
    
    // Validate date (no past dates)
    const validateDeliveryDate = () => {
        const today = dayjs().startOf('day');
        const selectedDate = formData.deliveryDate.startOf('day');
        
        if (selectedDate.isBefore(today)) {
            setSnackbar({ open: true, message: 'Delivery date cannot be in the past', severity: 'error' });
            return false;
        }
        return true;
    };
    
    // Switch to view mode function
    const switchToViewMode = async () => {
        setMode('view');
        setIsFormDisabled(true);
        setOtpSent(false);
        setOtpVerified(false);
        setTimeRemaining(null);
        setBookingDisabled(false);
        
        // Refresh order data if we have an order ID
        if (currentOrderId) {
            await refreshOrderData(currentOrderId);
        }
    };
    
    
const handleUpdate = async () => {
    if (!globalPropertyId) {
        setSnackbar({ open: true, message: 'Please select a property', severity: 'error' });
        return;
    }
    if (!formData.institute) {
        setSnackbar({ open: true, message: 'Please select institute', severity: 'error' });
        return;
    }
    if (!formData.mealType) {
        setSnackbar({ open: true, message: 'Please select meal type', severity: 'error' });
        return;
    }
    if (!formData.dropAddress || formData.dropAddress.trim() === '') {
        setSnackbar({ open: true, message: 'Please select delivery address/location', severity: 'error' });
        return;
    }
    
    if (!validateBookingTime()) {
        return;
    }
    
    if (!validateDeliveryDate()) {
        return;
    }
    
    setSubmitting(true);
    
    try {
        const user = getUserData();
        if (!user) {
            setSnackbar({ open: true, message: 'User not found. Please login again.', severity: 'error' });
            return;
        }
        
        // Get current system time for Req_Date
        const currentDateTime = dayjs();
        
        // Combine date and time for delivery datetime
        const deliveryDateTime = dayjs(formData.deliveryDate)
            .hour(formData.deliveryTime.hour())
            .minute(formData.deliveryTime.minute());
        
        const payload = {
            Tfn_ReqId: currentOrderId,
            Req_Date: currentDateTime.format('YYYY-MM-DD HH:mm:ss'), // Changed: Now includes time
            Req_RaisedId: user.UserId,
            MealTypeId: parseInt(formData.mealType),
            Req_LockTime: formatTimeForAPI(dayjs().hour(parseInt(formData.orderTimeOriginal.split(':')[0])).minute(parseInt(formData.orderTimeOriginal.split(':')[1]))),
            Req_CanlTime: formatTimeForAPI(dayjs().hour(parseInt(formData.cancelTimeOriginal.split(':')[0])).minute(parseInt(formData.cancelTimeOriginal.split(':')[1]))),
            PropId: parseInt(globalPropertyId),
            BookId: 1,
            ResidentId: 1,
            InstituteId: parseInt(formData.institute),
            Dlv_Time: deliveryDateTime.format('YYYY-MM-DD HH:mm:ss'),
            Dlv_Loc: formData.dropAddress,
            Req_Qty: formData.tiffinCount,
            Req_Remark: formData.specialInstructions || "",
            Tfn_ReqSt: formData.status,
            Remark: `Order from ${formData.customerName || 'Guest'}`,
            Status: "1",
            CreatedBy: user.UserId,
            MobileNo: formData.phone || user.MobileNo || "" 
        };
        
        console.log('Updating payload:', payload);
        
        const response = await axiosInstance.post('TrnTiffin/UpdateTrnTiffin', payload);
        
        if (response.data?.Status === 0 || response.data?.Success) {
            toast.success(response.data.Message);
            
            // Refresh order data after update
            await refreshOrderData(currentOrderId);
            
            // Switch to view mode after successful update
            switchToViewMode();
        } else {
            throw new Error(response.data?.Message || 'Failed to update order');
        }
    } catch (err) {
        console.error('Error updating order:', err);
        setSnackbar({
            open: true,
            message: err.response?.data?.Message || err.message || 'Failed to update order. Please try again.',
            severity: 'error'
        });
    } finally {
        setSubmitting(false);
    }
};
    
   
const handleSubmit = async () => {
    if (!globalPropertyId) {
        setSnackbar({ open: true, message: 'Please select a property', severity: 'error' });
        return;
    }
    if (!formData.institute) {
        setSnackbar({ open: true, message: 'Please select institute', severity: 'error' });
        return;
    }
    if (!formData.mealType) {
        setSnackbar({ open: true, message: 'Please select meal type', severity: 'error' });
        return;
    }
    if (!formData.dropAddress || formData.dropAddress.trim() === '') {
        setSnackbar({ open: true, message: 'Please select delivery address/location', severity: 'error' });
        return;
    }
    
    if (!validateBookingTime()) {
        return;
    }
    
    if (!validateDeliveryDate()) {
        return;
    }
    
    setSubmitting(true);
    
    try {
        const user = getUserData();
        if (!user) {
            setSnackbar({ open: true, message: 'User not found. Please login again.', severity: 'error' });
            return;
        }
        
        // Get current system time for Req_Date
        const currentDateTime = dayjs();
        
        // Combine date and time for delivery datetime
        const deliveryDateTime = dayjs(formData.deliveryDate)
            .hour(formData.deliveryTime.hour())
            .minute(formData.deliveryTime.minute());
        
        const payload = {
            Req_Date: currentDateTime.format('YYYY-MM-DD HH:mm:ss'), // Changed: Now includes time
            Req_RaisedId: user.UserId,
            MealTypeId: parseInt(formData.mealType),
            Req_LockTime: formatTimeForAPI(dayjs().hour(parseInt(formData.orderTimeOriginal.split(':')[0])).minute(parseInt(formData.orderTimeOriginal.split(':')[1]))),
            Req_CanlTime: formatTimeForAPI(dayjs().hour(parseInt(formData.cancelTimeOriginal.split(':')[0])).minute(parseInt(formData.cancelTimeOriginal.split(':')[1]))),
            PropId: parseInt(globalPropertyId),
            BookId: 1,
            ResidentId: 1,
            InstituteId: parseInt(formData.institute),
            Dlv_Time: deliveryDateTime.format('YYYY-MM-DD HH:mm:ss'),
            Dlv_Loc: formData.dropAddress,
            Req_Qty: formData.tiffinCount,
            Req_Remark: formData.specialInstructions || "",
            Tfn_ReqSt: "Booked",
            Remark: `Order from ${formData.customerName || 'Guest'}`,
            Status: "1",
            CreatedBy: user.UserId,
            MobileNo: formData.phone || user.MobileNo || "" // Add mobile number
        };
        
        console.log('Submitting payload:', payload);
        
        const response = await axiosInstance.post('TrnTiffin/InsertTrnTiffin', payload);
        
        if (response.data?.Status === 0 || response.data?.Success) {
            // Try to get order data directly from response first
            let orderData = null;
            let newOrderId = null;
            
            // Check if response has Data with order details
            if (response.data?.Data && response.data.Data.length > 0) {
                orderData = response.data.Data[0];
                newOrderId = orderData.Tfn_ReqId;
            } else if (response.data?.Tfn_ReqId) {
                newOrderId = response.data.Tfn_ReqId;
            } else if (response.data?.Data?.Tfn_ReqId) {
                newOrderId = response.data.Data.Tfn_ReqId;
            }
            
            if (newOrderId) {
                setCurrentOrderId(newOrderId);
                
                // If we already have order data with OTP, use it
                if (orderData && orderData.Dlv_OTP) {
                    setCurrentOrderData(orderData);
                    setFormData(prev => ({
                        ...prev,
                        otp: orderData.Dlv_OTP || '',
                        customerName: orderData.Remark?.replace('Order from ', '') || prev.customerName,
                        phone: orderData.MobileNo || prev.phone,
                    }));
                    toast.success(`Order placed successfully! OTP: ${orderData.Dlv_OTP}`);
                } else {
                    // Otherwise fetch with retry
                    toast.success(response.data.Message || 'Order placed successfully!');
                    await refreshOrderData(newOrderId);
                }
            } else {
                toast.success(response.data.Message || 'Order placed successfully!');
            }
            
            // Switch to view mode after successful submit
            switchToViewMode();
        } else {
            throw new Error(response.data?.Message || 'Failed to submit order');
        }
    } catch (err) {
        console.error('Error submitting order:', err);
        setSnackbar({
            open: true,
            message: err.response?.data?.Message || err.message || 'Failed to submit order. Please try again.',
            severity: 'error'
        });
    } finally {
        setSubmitting(false);
    }
};
    
    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setCurrentOrderId(null);
        setCurrentOrderData(null);
        setFormData({
            customerName: '', phone: '', institute: '', instituteName: '',
            mealType: '', mealTypeName: '', pickupAddress: '', dropAddress: '',
            otp: '', tiffinCount: 1, selectedMenu: null,
            deliveryDate: dayjs(), deliveryTime: dayjs(),
            orderTime: '', orderTimeOriginal: '', cancelTime: '', cancelTimeOriginal: '',
            specialInstructions: '', status: 'Pending'
        });
        setDropLocations([]);
        setOtpSent(false);
        setOtpVerified(false);
        setTimeRemaining(null);
        setBookingDisabled(false);
    };
    
    const handleEdit = () => {
        setMode('edit');
        setIsFormDisabled(false);
    };
    
    const handleCancel = () => {
        // Reset to view mode with existing data
        if (currentOrderData) {
            // Reload from original data
            setFormData({
                customerName: currentOrderData.Remark?.replace('Order from ', '') || '',
                phone: currentOrderData.MobileNo || '',
                institute: currentOrderData.InstituteId?.toString() || '',
                instituteName: currentOrderData.InstituteName || '',
                mealType: currentOrderData.MealTypeId?.toString() || '',
                mealTypeName: currentOrderData.MealTypeName || '',
                pickupAddress: currentOrderData.PickupAddress || '',
                dropAddress: currentOrderData.Dlv_Loc || '',
                otp: currentOrderData.Dlv_OTP || '',
                tiffinCount: currentOrderData.Req_Qty || 1,
                selectedMenu: null,
                deliveryDate: currentOrderData.Dlv_Time ? dayjs(currentOrderData.Dlv_Time) : dayjs(),
                deliveryTime: currentOrderData.Dlv_Time ? dayjs(currentOrderData.Dlv_Time) : dayjs(),
                orderTime: currentOrderData.Req_LockTime ? formatTimeForDisplay(currentOrderData.Req_LockTime) : '',
                orderTimeOriginal: currentOrderData.Req_LockTime ? formatTimeForDisplay(currentOrderData.Req_LockTime) : '',
                cancelTime: currentOrderData.Req_CanlTime ? formatTimeForDisplay(currentOrderData.Req_CanlTime) : '',
                cancelTimeOriginal: currentOrderData.Req_CanlTime ? formatTimeForDisplay(currentOrderData.Req_CanlTime) : '',
                specialInstructions: currentOrderData.Req_Remark || '',
                status: currentOrderData.Tfn_ReqSt || 'Pending'
            });
        }
        switchToViewMode();
    };
    
    const handleCancelexit = () => {
        navigate('/TiffinDeliverytable');
    };
    
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };
    
    const formatTimerDisplay = () => {
        if (!timeRemaining) return '--:--:--';
        if (timeRemaining.isExpired) return '00:00:00';
        return `${String(timeRemaining.hours).padStart(2, '0')}:${String(timeRemaining.minutes).padStart(2, '0')}:${String(timeRemaining.seconds).padStart(2, '0')}`;
    };
    
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box className="form-container" sx={{ height: { xs: 'auto', sm: 'auto' }, p: 0 }}>
                <Box sx={{ height: 3, background: 'linear-gradient(90deg, #635bff 0%, #a78bfa 50%, #635bff 100%)' }} />
                <ToastContainer/>
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title' sx={{
                        display: 'flex', alignItems: 'center',
                        justifyContent: 'space-between', mt: 2,
                        flexDirection: { xs: 'column', sm: 'row' }
                    }}>
                        <Grid sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-start' }, mb: { xs: 1, sm: 0 } }}>
                            <Button variant="contained" size="small" className='three-d-button-previous'
                                disabled={mode !== 'view'}
                                sx={{ backgroundColor: '#635BFF', mr: 1, display: { xs: 'none', sm: 'flex' } }}>
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button variant="contained" size="small" className='three-d-button-next'
                                disabled={mode !== 'view'}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'flex' } }}>
                                <NavigateNextIcon />
                            </Button>
                        </Grid>
                        
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mx: 'auto' }}>
                            <Box sx={{
                                width: 36, height: 36, borderRadius: '10px',
                                background: 'linear-gradient(135deg, #635bff, #a78bfa)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                boxShadow: '0 4px 12px rgba(99,91,255,0.3)'
                            }}>
                                <TwoWheelerIcon sx={{ color: 'white', fontSize: 20 }} />
                            </Box>
                            <Typography variant="h5" sx={{
                                fontWeight: 700, letterSpacing: '-0.5px',
                                fontSize: { xs: '20px', sm: '18px', md: '22px' }
                            }}>
                               Tiffin Service
                            </Typography> 
                        </Box>
                        
                        <Grid sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 2 }}>
                            <CrudButtons
                                moduleName={"Tiffin Service"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                readOnlyMode={isFormDisabled}
                                onExit={handleCancelexit}
                                onCancel={handleCancel} 
                            />
                        </Grid>
                    </Grid>
                    
                    <Grid item xs={12} className='form_field'>
                        <Typography variant="caption" sx={{
                            mb: 1, display: 'block', fontWeight: 700, color: '#635bff',
                            textTransform: 'uppercase', letterSpacing: 1
                        }}>
                            Order Details
                        </Typography>
                    </Grid>
                    
                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={1.5}>
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth variant="filled" className="custom-textfield">
                                    <InputLabel>Institute Name</InputLabel>
                                    <Select
                                        name="institute"
                                        value={formData.institute}
                                        onChange={handleInstituteChange}
                                        disabled={isFormDisabled || loadingInstitutes}
                                        endAdornment={
                                            loadingInstitutes
                                                ? <CircularProgress size={16} sx={{ mr: 2, color: '#635bff' }} />
                                                : null
                                        }
                                    >
                                        {institutes.map(inst => (
                                            <MenuItem key={inst.Id} value={inst.Id}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <SchoolIcon sx={{ fontSize: 16, color: '#635bff' }} />
                                                    {inst.Name}
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth variant="filled" className="custom-textfield">
                                    <InputLabel>Meal Type</InputLabel>
                                    <Select
                                        name="mealType"
                                        value={formData.mealType}
                                        onChange={handleMealTypeChange}
                                        disabled={isFormDisabled || loadingMealTypes}
                                        endAdornment={
                                            loadingMealTypes
                                                ? <CircularProgress size={16} sx={{ mr: 2, color: '#635bff' }} />
                                                : null
                                        }
                                    >
                                        {mealTypes.map(meal => (
                                            <MenuItem key={meal.MealTypeId} value={meal.MealTypeId}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <RestaurantIcon sx={{ fontSize: 16, color: '#635bff' }} />
                                                    <span>{meal.MealTypeName}</span>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            
                            <Grid item xs={12} md={4}>
                                <TextField fullWidth variant="filled" label="Enter OTP" name="otp"
                                    value={formData.otp} onChange={handleChange}
                                    disabled={!otpSent || isFormDisabled} className="custom-textfield"
                                    inputProps={{ maxLength: 6 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                {otpVerified
                                                    ? <CheckCircleIcon sx={{ color: '#22c55e', fontSize: 18 }} />
                                                    : <LockIcon sx={{ color: '#635bff', fontSize: 18 }} />}
                                            </InputAdornment>
                                        ),
                                        
                                    }}
                                />
                            </Grid>

                             <Grid item xs={12} md={4}>
                                <FormControl fullWidth variant="filled" className="custom-textfield">
                                    <InputLabel>Delivery Address/Location</InputLabel>
                                    <Select
                                        name="dropAddress"
                                        value={formData.dropAddress}
                                        onChange={handleChange}
                                        disabled={isFormDisabled || !formData.institute || loadingDropLocations}
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <LocationOnIcon sx={{ color: '#f97316', fontSize: 18 }} />
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            loadingDropLocations
                                                ? <CircularProgress size={16} sx={{ mr: 2, color: '#635bff' }} />
                                                : null
                                        }
                                    >
                                        {!formData.institute && (
                                            <MenuItem disabled value="">
                                                <em>Select institute first</em>
                                            </MenuItem>
                                        )}
                                        {formData.institute && !loadingDropLocations && dropLocations.length === 0 && (
                                            <MenuItem disabled value="">
                                                <em>No locations found</em>
                                            </MenuItem>
                                        )}
                                        {dropLocations.map((loc, idx) => (
                                            <MenuItem key={`${loc.Id}-${idx}`} value={loc.Tiffin_Loc}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Box>
                                                        <Typography variant="body2" fontWeight={600}>
                                                            {loc.Tiffin_Loc}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            
                            {/* Split Delivery Date and Time Fields */}
                            <Grid item xs={12} md={2.5}>
                                <DatePicker
                                    label="Delivery Date"
                                    value={formData.deliveryDate}
                                    onChange={(newDate) => setFormData(prev => ({ ...prev, deliveryDate: newDate }))}
                                    disabled={isFormDisabled}
                                    disablePast
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            variant: 'filled',
                                            className: 'custom-textfield',
                                            InputProps: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <EventIcon sx={{ color: '#635bff', fontSize: 18 }} />
                                                    </InputAdornment>
                                                )
                                            }
                                        }
                                    }}
                                />
                            </Grid>
                            
                            <Grid item xs={12} md={1.5}>
                                <MobileTimePicker
                                    label="Delivery Time"
                                    value={formData.deliveryTime}
                                    onChange={(newTime) => setFormData(prev => ({ ...prev, deliveryTime: newTime }))}
                                    disabled={isFormDisabled}
                                    ampm={false}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            variant: 'filled',
                                            className: 'custom-textfield',
                                            InputProps: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AccessTimeIcon sx={{ color: '#635bff', fontSize: 18 }} />
                                                    </InputAdornment>
                                                )
                                            }
                                        }
                                    }}
                                />
                            </Grid>
                            
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    label="Order Time (Lock Time)"
                                    name="orderTime"
                                    value={formData.orderTime}
                                    disabled={true}
                                    className="custom-textfield"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ScheduleIcon sx={{ color: '#635bff', fontSize: 18 }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    variant="filled"
                                    label="Cancel Time"
                                    name="cancelTime"
                                    value={formData.cancelTime}
                                    disabled={true}
                                    className="custom-textfield"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <CancelIcon sx={{ color: '#ef4444', fontSize: 18 }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            
                           
                            
                          <Grid item xs={12} md={2}>
    <Box sx={{
        background: 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)',
        border: '2px solid #635bff',
        borderRadius: 2,
        px: 1.5,
        py: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        justifyContent: 'center',
        minHeight: 56,
        opacity: isFormDisabled ? 0.65 : 1,
        transition: 'all 0.3s ease',
        '&:hover': !isFormDisabled && {
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(99,91,255,0.2)'
        }
    }}>
        <Typography variant="caption" fontWeight={700} color="#635bff" sx={{ mb: 0.5 }}>
            No. of Tiffins
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <IconButton size="small" onClick={() => handleTiffinCount('dec')}
                disabled={isFormDisabled || bookingDisabled}
                sx={{
                    background: '#fff',
                    border: '1.5px solid #ede9fe',
                    width: 26,
                    height: 26,
                    '&:hover': { background: '#635bff', color: 'white' }
                }}>
                <RemoveIcon sx={{ fontSize: 14, color: 'inherit' }} />
            </IconButton>
            <TextField
                value={formData.tiffinCount}
                onChange={handleTiffinInput}
                disabled={isFormDisabled || bookingDisabled}
                type="number"
                inputProps={{
                    min: 1,
                    // Remove max property
                    style: {
                        textAlign: 'center',
                        fontWeight: 800,
                        fontSize: 16,
                        color: '#635bff',
                        padding: '2px 0',
                        width: 60  // Width increase kiya for more digits
                    }
                }}
                variant="standard"
                sx={{
                    width: 70,  // Width increase kiya
                    '& .MuiInput-underline:before': { borderBottom: '1.5px solid #ede9fe' },
                    '& .MuiInput-underline:after': { borderBottom: '2px solid #635bff' },
                    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': { display: 'none' },
                }}
            />
            <IconButton size="small" onClick={() => handleTiffinCount('inc')}
                disabled={isFormDisabled || bookingDisabled}
                sx={{
                    background: '#635bff',
                    border: '1.5px solid #635bff',
                    width: 26,
                    height: 26,
                    '&:hover': { background: '#524ccc' }
                }}>
                <AddIcon sx={{ fontSize: 14, color: 'white' }} />
            </IconButton>
        </Box>
    </Box>
</Grid>

                            {timeRemaining && mode !== 'view' && (
    <Grid item xs={12} md={2}>
        <Paper elevation={0} sx={{
            background: timeRemaining.isExpired || bookingDisabled
                ? 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)'
                : timeRemaining.totalSeconds <= 1800 && !timeRemaining.isExpired
                ? 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
                : 'linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)',
            border: timeRemaining.isExpired || bookingDisabled ? '2px solid #ef4444' : 
                    timeRemaining.totalSeconds <= 1800 ? '2px solid #f59e0b' : '2px solid #3b82f6',
            borderRadius: 3,
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            animation: timeRemaining.totalSeconds <= 600 && !timeRemaining.isExpired && !bookingDisabled ? 'pulse 1s infinite' : 'none',
            '@keyframes pulse': {
                '0%': { opacity: 1, transform: 'scale(1)' },
                '50%': { opacity: 0.8, transform: 'scale(1.02)' },
                '100%': { opacity: 1, transform: 'scale(1)' },
            }
        }}>
            <TimerIcon sx={{ 
                color: timeRemaining.isExpired || bookingDisabled ? '#ef4444' : 
                       timeRemaining.totalSeconds <= 1800 ? '#f59e0b' : '#3b82f6', 
                fontSize: 28 
            }} />
            <Box sx={{ textAlign: 'center' }}>
                
<Typography variant="caption" sx={{
    color: timeRemaining.isExpired || bookingDisabled ? '#991b1b' : 
           timeRemaining.totalSeconds <= 1800 ? '#92400e' : '#1e40af',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: 1,
    display: 'block'
}}>
    {timeRemaining.isExpired || bookingDisabled 
        ? `Order Closed ${formData.deliveryDate.format('DD/MM/YYYY')}` 
        : `Time to order ${formData.deliveryDate.format('DD/MM/YYYY')}`}
</Typography>
                <Typography variant="h6" sx={{
                    color: timeRemaining.isExpired || bookingDisabled ? '#dc2626' : 
                           timeRemaining.totalSeconds <= 1800 ? '#ea580c' : '#2563eb',
                    fontWeight: 800,
                    fontFamily: 'monospace',
                    fontSize: '1.1rem'
                }}>
                    {formatTimerDisplay()}
                </Typography>
            </Box>
        </Paper>
    </Grid>
)}
                            
                            <Grid item xs={12}>
                                <TextField fullWidth variant="filled"
                                    label="Special Instructions" name="specialInstructions"
                                    value={formData.specialInstructions} onChange={handleChange}
                                    disabled={isFormDisabled} className="custom-textfield"
                                    multiline rows={2}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    
                    {(formData.mealType || formData.institute) && (
                        <Grid item xs={12}>
                            <Paper elevation={0} sx={{
                                background: 'linear-gradient(135deg, rgba(99,91,255,0.04), rgba(167,139,250,0.08))',
                                border: '1.5px solid #ede9fe',
                                borderRadius: 3,
                                p: 1.5,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                flexWrap: 'wrap'
                            }}>
                                <Typography variant="caption" sx={{
                                    color: '#888',
                                    fontWeight: 700,
                                    textTransform: 'uppercase',
                                    letterSpacing: 0.8
                                }}>
                                    Order Summary:
                                </Typography>
                                {formData.instituteName && (
                                    <Chip size="small" icon={<SchoolIcon />} label={formData.instituteName}
                                        sx={{ background: '#ede9fe', color: '#635bff', fontWeight: 600 }} />
                                )}
                                {formData.mealTypeName && (
                                    <Chip size="small" icon={<RestaurantIcon />} label={formData.mealTypeName}
                                        sx={{ background: '#fef3c7', color: '#d97706', fontWeight: 600 }} />
                                )}
                                {formData.dropAddress && (
                                    <Chip size="small" icon={<LocationOnIcon />} label={formData.dropAddress}
                                        sx={{ background: '#fff7ed', color: '#f97316', fontWeight: 600 }} />
                                )}
                                {formData.tiffinCount && (
                                    <Chip size="small" label={`${formData.tiffinCount} Tiffin(s)`}
                                        sx={{ background: '#e8f5e9', color: '#16a34a', fontWeight: 600 }} />
                                )}
                                {formData.orderTime && (
                                    <Chip size="small" icon={<ScheduleIcon />} label={`Order by: ${formData.orderTime}`}
                                        sx={{ background: '#e0f2fe', color: '#0284c7', fontWeight: 600 }} />
                                )}
                                {formData.cancelTime && (
                                    <Chip size="small" icon={<CancelIcon />} label={`Cancel by: ${formData.cancelTime}`}
                                        sx={{ background: '#fee2e2', color: '#dc2626', fontWeight: 600 }} />
                                )}
                                {formData.deliveryDate && (
                                    <Chip size="small" icon={<AccessTimeIcon />} label={formData.deliveryDate.format('DD/MM/YYYY')}
                                        sx={{ background: '#f0f0ff', color: '#635bff', fontWeight: 600 }} />
                                )}
                                {formData.deliveryTime && (
                                    <Chip size="small" icon={<AccessTimeIcon />} label={`Delivery Time: ${formData.deliveryTime.format('HH:mm')}`}
                                        sx={{ background: '#f0f0ff', color: '#635bff', fontWeight: 600 }} />
                                )}
                                {mode === 'edit' && formData.status && (
                                    <Chip size="small" label={`Status: ${formData.status}`}
                                        sx={{ 
                                            background: formData.status === 'Approved' ? '#e8f5e9' : 
                                                       formData.status === 'Pending' ? '#fff7ed' : 
                                                       formData.status === 'Cancelled' ? '#fee2e2' : '#e0f2fe',
                                            color: formData.status === 'Approved' ? '#16a34a' : 
                                                   formData.status === 'Pending' ? '#f97316' : 
                                                   formData.status === 'Cancelled' ? '#dc2626' : '#0284c7',
                                            fontWeight: 600 
                                        }} />
                                )}
                                {bookingDisabled && mode !== 'view' && (
                                    <Chip size="small" label="Booking Closed"
                                        sx={{ background: '#fee2e2', color: '#dc2626', fontWeight: 600 }} />
                                )}
                            </Paper>
                        </Grid>
                    )}
                    
  <Grid item xs={12} className="form_button" sx={{ pb: 2 }}>
    {mode === 'add' && !bookingDisabled && (
        <Button variant="contained" onClick={handleSubmit}
            disabled={submitting || bookingDisabled}
            sx={{
                mr: 1,
                background: 'linear-gradient(135deg, #635bff 0%, #8b5cf6 100%)',
                ':hover': {
                    background: 'linear-gradient(135deg, #524ccc 0%, #7c3aed 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 20px rgba(99,91,255,0.4)'
                },
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1,
                transition: 'all 0.3s ease',
                '&:disabled': { background: '#ccc', transform: 'none' }
            }}>
            {submitting ? <CircularProgress size={24} color="inherit" /> : 'Submit Order'}
        </Button>
    )}
    
    {mode === 'edit' && !bookingDisabled && (
        <>
            {/* Show Update button only if order is not cancelled */}
            {formData.status !== 'Cancelled' && (
                <Button variant="contained" onClick={handleUpdate}
                    disabled={submitting || bookingDisabled}
                    sx={{
                        mr: 1,
                        background: 'linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)',
                        ':hover': {
                            background: 'linear-gradient(135deg, #d97706 0%, #c2410c 100%)',
                            transform: 'translateY(-2px)',
                            boxShadow: '0 6px 20px rgba(245,158,11,0.4)'
                        },
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                        transition: 'all 0.3s ease',
                        '&:disabled': { background: '#ccc', transform: 'none' }
                    }}>
                    {submitting ? <CircularProgress size={24} color="inherit" /> : 'Update Order'}
                </Button>
            )}
            
            {/* Show Cancel Order button for non-cancelled orders */}
            {formData.status !== 'Cancelled' && (
                <Button variant="contained" onClick={() => setCancelDialogOpen(true)}
                    disabled={cancelling}
                    sx={{
                        mr: 1,
                        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                        ':hover': {
                            background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                            transform: 'translateY(-2px)',
                            boxShadow: '0 6px 20px rgba(239,68,68,0.4)'
                        },
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                        transition: 'all 0.3s ease',
                        '&:disabled': { background: '#ccc', transform: 'none' }
                    }}>
                    {cancelling ? <CircularProgress size={24} color="inherit" /> : 'Cancel Order'}
                </Button>
            )}
            
            {/* Show Restore Order button for cancelled orders */}
            {formData.status === 'Cancelled' && (
                <Button variant="contained" onClick={handleRestoreOrder}
                    disabled={submitting || bookingDisabled}
                    sx={{
                        mr: 1,
                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        ':hover': {
                            background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                            transform: 'translateY(-2px)',
                            boxShadow: '0 6px 20px rgba(16,185,129,0.4)'
                        },
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                        transition: 'all 0.3s ease',
                        '&:disabled': { background: '#ccc', transform: 'none' }
                    }}>
                    {submitting ? <CircularProgress size={24} color="inherit" /> : 'Restore Order'}
                </Button>
            )}
        </>
    )}
    
    {(mode === 'edit' || mode === 'add') && (
        <Button variant="contained" onClick={handleCancel}
            sx={{
                mr: 1,
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1,
                background: '#6b7280',
                ':hover': {
                    background: '#4b5563',
                    transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
            }}>
            Cancel
        </Button>
    )}
</Grid>
                </Grid>
                
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Alert 
                        onClose={handleCloseSnackbar} 
                        severity={snackbar.severity} 
                        sx={{ 
                            width: '100%',
                            '& .MuiAlert-icon': {
                                color: snackbar.severity === 'success' ? '#16a34a' : '#ef4444'
                            }
                        }}
                    >
                        {snackbar.message}
                    </Alert>
                </Snackbar>
                {/* Cancel Confirmation Dialog */}
<Dialog
    open={cancelDialogOpen}
    onClose={() => setCancelDialogOpen(false)}
    PaperProps={{
        sx: {
            borderRadius: 3,
            padding: 1,
            minWidth: 400
        }
    }}
>
    <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1,
        borderBottom: '1px solid #e5e7eb',
        pb: 2
    }}>
        <CancelIcon sx={{ color: '#ef4444', fontSize: 28 }} />
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#ef4444' }}>
            Cancel Order Confirmation
        </Typography>
    </DialogTitle>
    <DialogContent sx={{ mt: 2 }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
            Are you sure you want to cancel this order?
        </Typography>
        <Box sx={{ 
            bgcolor: '#fef2f2', 
            p: 2, 
            borderRadius: 2,
            mt: 2,
            border: '1px solid #fecaca'
        }}>
            <Typography variant="body2" color="text.secondary">
                <strong>Order ID:</strong> {currentOrderId}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                <strong>Meal Type:</strong> {formData.mealTypeName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                <strong>Delivery Date:</strong> {formData.deliveryDate.format('DD/MM/YYYY')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                <strong>Tiffin Count:</strong> {formData.tiffinCount}
            </Typography>
        </Box>
        <Typography variant="body2" color="error" sx={{ mt: 2, fontWeight: 500 }}>
            Warning: This action cannot be undone!
        </Typography>
    </DialogContent>
    <DialogActions sx={{ p: 2, gap: 1, borderTop: '1px solid #e5e7eb', mt: 1 }}>
        <Button 
            onClick={() => setCancelDialogOpen(false)}
            disabled={cancelling}
            sx={{
                textTransform: 'none',
                fontWeight: 600,
                color: '#6b7280',
                '&:hover': { bgcolor: '#f3f4f6' }
            }}
        >
            No, Keep Order
        </Button>
        <Button 
            onClick={handleCancelOrder}
            disabled={cancelling}
            variant="contained"
            sx={{
                background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                '&:hover': {
                    background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                },
                '&:disabled': { background: '#ccc' }
            }}
        >
            {cancelling ? <CircularProgress size={24} color="inherit" /> : 'Yes, Cancel Order'}
        </Button>
    </DialogActions>
</Dialog>
            </Box>
        </LocalizationProvider>
    );
};

export default TiffinDelivery;